module.exports = __webpack_public_path__ + "img/icon_calendar.4d22ec60.svg";